<template>
  <div class="wrap">
    <el-form :inline="true">
      <el-form-item>
        <el-date-picker
          v-model="allAttribute.time"
          :picker-options="setBatchPickerOptions()"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择期望发货日期"
          class="form-item-cell"
        />
      </el-form-item>

      <el-form-item>
        <el-select
          v-model="allAttribute.freight"
          placeholder="请选择货运属性"
          class="form-item-cell"
        >
          <el-option
            v-for="(value, key) in freightProperty"
            :key="key"
            :label="value"
            :value="key"
          />
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-select
          v-model="taxRate"
          placeholder="请选择税率"
          class="form-item-cell"
        >
          <el-option
            v-for="item in taxRateList"
            :key="item.dictLabel"
            :label="item.dictValue"
            :value="item.dictLabel"
          />
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="batchSettings">
          批量设置
        </el-button>
        <el-button type="default" @click="setMaterialNum()">
          设置料号
        </el-button>
        <el-button type="default" @click="addNewRow">
          添加产品行
        </el-button>
        <el-button type="default" @click="batchDeatail">
          删除勾选产品行
        </el-button>
        <el-button type="default" @click="taxRateSettings">
          批量设置税率
        </el-button>
      </el-form-item>
    </el-form>

    <div style="color: red">
      注:1.若批量设置的日期不在客期可选范围,则需要重新设置或在产品行上单独设置
      2.若代理商发布合同时间和订单员发布合同时间间隔大于2天,则期望发货日期会在选择的日期上顺延相应间隔天数
    </div>

    <!-- 表格 -->
    <el-table
      :data="productList"
      border
      show-summary
      :summary-method="getSummaries"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55" fixed="left" />

      <el-table-column type="index" width="50" label="序号" align="left" fixed="left">
        <template v-slot="{ row, $index }">
          {{ (row.itemIndex = $index + 1) }}
        </template>
      </el-table-column>

      <el-table-column
        prop="productCode"
        label="销售代码"
        align="left"
        min-width="140"
      />

      <el-table-column
        prop="productName"
        label="产品型号"
        align="left"
        min-width="160"
      >
        <template v-slot="{ row }">
          <choose-product
            :row="row"
            :form="form"
            @change="changeChooseProduct"
          />
        </template>
      </el-table-column>

      <el-table-column label="料号" align="left" min-width="120">
        <template v-slot="{ row, $index }">
          <el-button type="text" @click="setSingleMaterialNum(row, $index)">
            {{ row.materialNumberId ? row.materialNumberId : "选择料号" }}
          </el-button>
        </template>
      </el-table-column>

      <el-table-column
        v-if="contractType !== '服务订单'"
        prop="productNum"
        label="数量"
        align="left"
        width="150"
      >
        <template v-slot="{ row }">
          <el-input-number
            v-model="row.productNum"
            :disabled="row.cloudDesktopMatching"
            :min="0"
            :controls="false"
            style="width: 100%"
            @blur="changeSetMoney(row)"
          />
        </template>
      </el-table-column>
      <el-table-column
        v-if="contractType === '服务订单'"
        prop="serviceLife"
        label="年限"
        align="left"
        width="90"
      >
        <template v-slot="{ row }">
          <el-input-number
            v-model="row.serviceLife"
            :disabled="row.cloudDesktopMatching"
            :min="0"
            :controls="false"
            style="width: 100%"
            @blur="changeSetMoney(row)"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="productPriceSigle"
        label="单价"
        align="right"
        header-align="left"
        min-width="135"
      >
        <template v-slot="{ row }">
          <el-input-number
            v-model="row.productPriceSigle"
            :disabled="row.cloudDesktopMatching"
            :min="0"
            :controls="false"
            style="width: 100%"
            @blur="changeSetMoney(row)"
          />
        </template>
      </el-table-column>

      <el-table-column
        prop="orderAmount"
        label="订单金额"
        align="right"
        header-align="left"
        min-width="135"
      />

      <el-table-column
        prop="settlementAmount"
        label="实际结算金额"
        align="right"
        header-align="left"
        min-width="135"
      >
        <template v-slot="{ row }">
          <el-input-number
            v-model="row.settlementAmount"
            :precision="2"
            :disabled="row.cloudDesktopMatching"
            :min="0"
            :controls="false"
            style="width: 100%"
          />
        </template>
      </el-table-column>

      <el-table-column
        prop="isBorrow"
        label="测试借条转订单"
        align="left"
        width="110"
      >
        <template v-slot="{ row, $index }">
          <el-checkbox
            v-model="row.isBorrow"
            @change="clickBorrow(row, $index)"
          />
        </template>
      </el-table-column>

      <el-table-column
        prop="expectedDeliveryDate"
        label="期望发货日期"
        align="left"
        width="160"
      >
        <template v-slot="{ row }">
          <el-date-picker
            v-model="row.expectedDeliveryDate"
            type="date"
            style="width: 100%"
            value-format="yyyy-MM-dd"
            placeholder="期望发货日期"
            :clearable="false"
            :picker-options="setSinglePickerOptions(row)"
          />
        </template>
      </el-table-column>

      <el-table-column
        v-if="!isUnDisabledConType"
        label="客期可选范围"
        align="left"
        min-width="180"
      >
        <template v-slot="{ row }">
          <div class="text-left">
            {{ setFormatRangDate(row) }}
          </div>
        </template>
      </el-table-column>

      <el-table-column
        prop="beforeSplitProductPriceSigle"
        label="拆分前单价"
        align="right"
        header-align="left"
        min-width="135"
      >
        <template v-slot="{ row }">
          <el-input-number
            v-model="row.beforeSplitProductPriceSigle"
            :min="0"
            :controls="false"
            style="width: 100%"
          />
        </template>
      </el-table-column>

      <el-table-column prop="pname" label="货运属性" align="left" width="140">
        <template v-slot="{ row }">
          <el-select v-model="row.freightProperty" placeholder="货运属性">
            <el-option
              v-for="(value, key) in freightProperty"
              :key="key"
              :label="value"
              :value="key"
            />
          </el-select>
        </template>
      </el-table-column>

      <el-table-column label="税率" align="right" header-align="left" width="130">
        <template v-slot="{ row }">
          <el-select v-model="row.rate" placeholder="请选择税率">
            <el-option
              v-for="item in taxRateList"
              :key="item.dictLabel"
              :label="item.dictValue"
              :value="item.dictLabel"
            />
          </el-select>
        </template>
      </el-table-column>

      <el-table-column label="操作" align="left" fixed="right" width="100">
        <template v-slot="{ row, $index }">
          <el-button
            v-if="!row.cloudDesktopMatching"
            type="text"
            style="padding: 0"
            @click="copyRow(row, $index)"
          >
            <i class="el-icon-circle-plus-outline" style="font-size: 16px" />
          </el-button>
          <el-button
            v-if="!row.cloudDesktopMatching"
            type="text"
            style="padding: 0; color: #f56c6c"
            @click="removeProduct($index)"
          >
            <i class="el-icon-delete" style="font-size: 16px" />
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 料号 -->
    <material-num ref="MaterialNum" @chooseMateria="chooseMateria" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import chooseProduct from '@/views/contractCommonInput/chooseProduct.vue';
import MaterialNum from '@/views/contractCommonInput/MaterialNum.vue';
import { getNum } from '@/libs/util';
import { getDictData } from '@/API/international';
import { calculateProductSettlementAmount } from '@/API/index.js';
import Big from 'big.js';
import dayjs from 'dayjs';

export default {
  components: {
    chooseProduct,
    MaterialNum
  },

  props: {
    rebateAmount: {
      type: [String, Number],
      default: 0
    },
    rebate: {
      type: [Number],
      default: 1
    },
    salesType: {
      type: [String, Number],
      default: ''
    },
    contractType: {
      type: String,
      default: ''
    },
    communicationOrderDiscount: {
      type: [String, Number],
      default: 1
    },
    form: {
      type: Object,
      default: () => { return {}; }
    },
    // table 列表数据
    list: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      allAttribute: {
        time: '',
        freight: '',
        btnNum: 0
      },
      // 税率
      taxRate: '',
      taxRateList: [],

      productList: [],
      // 表格多选框选中数据
      multipleSelection: [],

      summariesData: {
        productNum: 0,
        orderAmount: 0,
        settlementAmount: 0,
        beforeSplitProductPriceSigle: 0
      }
    };
  },

  computed: {
    ...mapState({
      // 货运属性
      freightProperty: state => state.enumeration.freightProperty
    }),

    // 接口不处理禁用客期规则的合同类型
    isUnDisabledConType () {
      if (this.hasEbgDeliveryRange) {
        return false;
      }
      return ['SMB分销下单', '国际业务下单', '国际分销下单', '价外费用', '新建订单合同', '服务订单'].includes(this.contractType);
    },
    hasEbgDeliveryRange () {
      return (this.form.departmentCode || '').startsWith('000062') &&
        this.productList.some(row => row.newDeliveryRule === true && row.minExpectedDate && row.maxExpectedDate && Array.isArray(row.holidayDates));
    },
    isServiceOrderType () {
      return this.contractType === '服务订单';
    }
  },

  watch: {
    list: {
      deep: true,
      handler (newval) {
        this.productList = newval;
      }
    }
  },

  created () {
    this.taxRateFn();
  },

  methods: {
    /**
     * 设置批量设置客期的禁用规则，规则：
     * 1. 接口处理的合同类型：满足条件的当天开始的90天可以选择
     * 2. 服务订单：不做限制，大于等于当天即可
     */
    setBatchPickerOptions () {
      let _this = this;
      return {
        disabledDate (time) {
          if (_this.hasEbgDeliveryRange &&
            ([0, 6].includes(dayjs(time).day()) || _this.productList.some(row => Array.isArray(row.holidayDates) && row.holidayDates.includes(dayjs(time).format('YYYY-MM-DD HH:mm:ss'))))) {
            return true;
          }
          if (_this.hasEbgDeliveryRange) {
            const minDate = _this.productList
              .filter(row => row.minExpectedDate)
              .map(row => dayjs(row.minExpectedDate))
              .sort((a, b) => a.valueOf() - b.valueOf())[0];
            const maxDate = _this.productList
              .filter(row => row.maxExpectedDate)
              .map(row => dayjs(row.maxExpectedDate))
              .sort((a, b) => b.valueOf() - a.valueOf())[0];
            return (minDate && dayjs(time).isBefore(minDate, 'day')) || (maxDate && dayjs(time).isAfter(maxDate, 'day'));
          } else if (!_this.isUnDisabledConType) {
            // 规则：直签项目 365 天可选择，其他当天开始的90天可以选择
            if (_this.form.asInterDirect) {
              return dayjs(time).isBefore(dayjs().subtract(1, 'day')) || dayjs(time).isAfter(dayjs().add(365, 'day'));
            } else {
              return dayjs(time).isBefore(dayjs().subtract(1, 'day')) || dayjs(time).isAfter(dayjs().add(89, 'day'));
            }
          } else if (_this.contractType === '服务订单') {
            return dayjs(time).isBefore(dayjs().subtract(1, 'day'));
          } else {
            return false;
          }
        }
      };
    },

    // 设置产品行客期的禁用规则
    setSinglePickerOptions (row) {
      let _this = this;

      return {
        disabledDate (time) {
          return row.productName ? _this.getRowDisabledRule(row, time) : false;
        }
      };
    },

    /**
     * 设置产品行客期的禁用规则，规则：
     * 1. 接口处理的合同类型：产品行规则 小于开始，大于结束，中间的法定节假日 禁用(接口字段盘判断)
     * 1.1 冲销：只有最小时间(接口返回的数据)
     * 2. 服务订单：不做限制，大于等于当天即可
     * 3. 其他：不做验证
    */
    getRowDisabledRule (row, time) {
      if (row.newDeliveryRule && [0, 6].includes(dayjs(time).day())) {
        return true;
      }
      if (!this.isUnDisabledConType) {
        let { minExpectedDate, maxExpectedDate, holidayDates } = row;
        if (minExpectedDate && maxExpectedDate && holidayDates) {
          return dayjs(time).isBefore(dayjs(minExpectedDate)) || holidayDates.includes(dayjs(time).format('YYYY-MM-DD HH:mm:ss')) || dayjs(time).isAfter(dayjs(maxExpectedDate));
        } else if (minExpectedDate && !maxExpectedDate && !holidayDates) {
          // 冲销
          return dayjs(time).isBefore(dayjs(minExpectedDate));
        } else {
          return false;
        }
      } else if (this.contractType === '服务订单') {
        return dayjs(time).isBefore(dayjs().subtract(1, 'day'));
      } else {
        return false;
      }
    },

    // 获取税率
    taxRateFn () {
      let params = { dictType: 'tax_rate' };
      getDictData(params).then(res => {
        let { status, data } = res.data;
        if (status === '200') {
          this.taxRateList = data;
        }
      });
    },

    // 批量设置
    batchSettings () {
      let error = '';
      this.productList.forEach((row) => {
        if (this.allAttribute.time) {
          // 产品行符合禁用规则可以进行赋值
          if (!this.getRowDisabledRule(row, this.allAttribute.time)) {
            this.$set(row, 'expectedDeliveryDate', this.allAttribute.time);
          }
        }

        if (this.allAttribute.freight) {
          this.$set(row, 'freightProperty', this.allAttribute.freight);
        }
      });

      if (error) {
        this.$notify.error({ message: error });
      }
    },

    // 客期可选范围
    setFormatRangDate (row) {
      let { minExpectedDate, maxExpectedDate } = row;
      if (minExpectedDate && maxExpectedDate) {
        return `${minExpectedDate.slice(0, 10)} ~ ${maxExpectedDate.slice(0, 10)}`;
      } else if (minExpectedDate && !maxExpectedDate) {
        return `${minExpectedDate.slice(0, 10)} ~ `;
      }
    },

    // 设置料号
    setMaterialNum (row, index) {
      if (!this.contractType) {
        this.$notify.error({ message: '请先选择订单分类' });
        return;
      }

      let productAndMaterialGroup = [];
      let MaterialNumValues = {};

      this.productList.forEach((item) => {
        if (item.productCode) {
          // if (this.isServiceOrderType) {
          //   productAndMaterialGroup.push({
          //     productSalesCode: item.productCode,
          //     productName: item.productName,
          //     exclusiveMaterial: item.materialNumberId,
          //     serviceLife: item.serviceLife,
          //     isHavePowerCord: item.isHavePowerCord || false,
          //     isTestOrder: item.isBorrow || false
          //   });
          // } else {
          productAndMaterialGroup.push({
            productSalesCode: item.productCode,
            productName: item.productName,
            exclusiveMaterial: item.materialNumberId,
            productNum: item.productNum,
            isHavePowerCord: item.isHavePowerCord || false,
            isTestOrder: item.isBorrow || false
          });
          // }
          MaterialNumValues[item.productCode] = {
            materialNumberId: item.materialNumberId,
            materialUnit: item.materialUnit
          };
        }
      });

      let param = {
        contractType: this.form.saleTypeName || '',
        contractNumber: this.form.contractNum,
        contractName: this.form.projectName,
        materialReqProductVOS: productAndMaterialGroup
      };

      this.$refs.MaterialNum.showdialog(param, index, MaterialNumValues);
    },

    // 设置单个料号
    setSingleMaterialNum (row, index) {
      if (!this.contractType) {
        this.$notify.error({ message: '请先选择订单分类' });
        return;
      }

      let productAndMaterialGroup = [];
      let MaterialNumValues = {};
      // debugger;

      if (row.productCode) {
        // if (this.isServiceOrderType) {
        //   productAndMaterialGroup.push({
        //     productSalesCode: row.productCode,
        //     productName: row.productName,
        //     exclusiveMaterial: row.materialNumberId,
        //     serviceLife: row.serviceLife,
        //     isHavePowerCord: row.isHavePowerCord || false,
        //     isTestOrder: row.isBorrow || false
        //   });
        // } else {
        productAndMaterialGroup.push({
          productSalesCode: row.productCode,
          productName: row.productName,
          exclusiveMaterial: row.materialNumberId,
          productNum: row.productNum,
          isHavePowerCord: row.isHavePowerCord || false,
          isTestOrder: row.isBorrow || false
        });
        // }
        MaterialNumValues[row.productCode] = {
          materialNumberId: row.materialNumberId,
          materialUnit: row.materialUnit
        };
      }

      let param = {
        contractType: this.form.saleTypeName || '',
        contractNumber: this.form.contractNum,
        contractName: this.form.projectName,
        materialReqProductVOS: productAndMaterialGroup
      };

      this.$refs.MaterialNum.showdialog(param, index, MaterialNumValues);
    },

    // 选择料号回调
    chooseMateria ({ list, RowIndex }) {
      // 设置表单值
      let setTableProps = (RowIndex, data) => {
        this.productList[RowIndex].materialNumberId = data.selected;
        this.productList[RowIndex].materialUnit = data.materialUnit;
        this.productList[RowIndex].softFlag = data.softFlag;
      };

      // 判断是否是设置单个料号
      if (RowIndex === 'all') {
        list.forEach((data, index) => {
          let row = this.productList[index];
          if (row.productCode === data.productSalesCode) {
            setTableProps(index, data);
          }
        });
      } else {
        setTableProps(RowIndex, list[0]);
      }
    },

    // 添加行
    addNewRow () {
      if (this.isServiceOrderType) {
        this.productList.push({
          orderAmount: 0,
          settlementAmount: 0,
          serviceLife: 0,
          materialNumberId: '',
          productPriceSigle: 0,
          removeVisible: false,
          expectedDeliveryDate: ''
        });
      } else {
        this.productList.push({
          orderAmount: 0,
          settlementAmount: 0,
          productNum: 0,
          materialNumberId: '',
          productPriceSigle: 0,
          removeVisible: false,
          expectedDeliveryDate: ''
        });
      }
    },

    // table 多选框 获取选中数据
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },

    // 删除勾选产品行
    batchDeatail () {
      if (this.multipleSelection.length === 0) {
        this.$message.error('请勾选需要删除产品行');
        return;
      }
      this.$confirm('是否删除勾选产品行?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let list = this.multipleSelection.map(row => row.itemIndex);
          this.productList = this.productList.filter(row => !list.includes(row.itemIndex));
          this.multipleSelection = [];
        })
        .catch(() => { });
    },

    // 批量设置税率
    taxRateSettings () {
      if (this.taxRate) {
        this.productList.forEach((item) => {
          this.$set(item, 'rate', this.taxRate);
        });
      }
    },

    // 复制行
    copyRow (row, index) {
      this.productList.splice(index + 1, 0, { ...this.$cloneDeep(row), id: null });
    },

    // 删除行
    removeProduct (index) {
      this.$confirm('是否删除该产品?', '提示', {
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.productList.splice(index, 1);
        })
        .catch(() => { });
    },

    Recalculation () { },

    // 产品选择回调
    changeChooseProduct (item) {
      let row = this.productList[item.row.itemIndex - 1];
      // 料号materialNumberId
      if (item.data.materialNumberId) {
        this.$set(row, 'materialNumberId', item.data.materialNumberId);
      }
      if (item.data.materialUnit) {
        this.$set(row, 'materialUnit', item.data.materialUnit);
      }

      let { expectedDeliveryDate, minExpectedDate, maxExpectedDate, holidayDates } = item.data;
      // 期望发货日期
      this.$set(row, 'expectedDeliveryDate', expectedDeliveryDate || '');
      // 设置禁用规则
      minExpectedDate && this.$set(row, 'minExpectedDate', minExpectedDate);
      maxExpectedDate && this.$set(row, 'maxExpectedDate', maxExpectedDate);
      holidayDates && this.$set(row, 'holidayDates', holidayDates);
      // 货运属性
      if (item.data.freightPropertyCode) {
        this.$set(row, 'freightProperty', item.data.freightPropertyCode);
      }
    },

    // 测试借条转订单
    clickBorrow (row, index) {
      if (row.isBorrow) {
        this.productList[index].freightProperty = '20';
      } else {
        this.productList[index].freightProperty = '';
      }
    },
    // 数量、单价，变更调用接口计算获取：订单金额和实际结算金额
    changeSetMoney (row) {
      const type = this.contractType === '服务订单';
      let params = {
        // 合同返点
        rebate: this.rebate,
        // 返利金额
        rebateAmount: this.rebateAmount,
        // 通讯折扣
        communicationOrderDiscount: this.communicationOrderDiscount,
        // 1 现销 2 赊销
        salesType: this.salesType,
        productList: this.productList.map((item) => ({
          id: item.id,
          productCode: item.productCode,
          productCategoryName: item.productCategoryName,
          productPriceSingle: item.productPriceSigle,
          productNum: type ? item.serviceLife : item.productNum
        }))
      };
      this.isLoading = true;

      calculateProductSettlementAmount(params)
        .then(res => {
          let { status, data } = res.data;
          this.isLoading = false;
          if (status === '200') {
            this.productList.forEach((item, index) => {
              let result = data[index];
              item.orderAmount = result.orderAmount;
              item.settlementAmount = result.settlementAmount;
            });
          }
        })
        .catch(() => {
          row.productNum = 0;
          row.productPriceSigle = 0;
          row.orderAmount = 0;
          row.settlementAmount = 0;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    // 计算合计
    getSummaries ({ columns, data }) {
      let sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.label === '数量') {
          sums[index] = data.reduce((pre, cur) => getNum(Big(getNum(this.contractType === '服务订单' ? cur.serviceLife : cur.productNum)).plus(pre).toString()), 0);
          this.summariesData.productNum = sums[index];
          return;
        }
        if (column.label === '订单金额') {
          sums[index] = data.reduce((pre, cur) => getNum(Big(getNum(cur.orderAmount)).plus(pre).toString()), 0);
          this.summariesData.orderAmount = sums[index];
          return;
        }
        if (column.label === '实际结算金额') {
          sums[index] = data.reduce((pre, cur) => getNum(Big(getNum(cur.settlementAmount)).plus(pre).toString()), 0);
          this.summariesData.settlementAmount = sums[index];
          return;
        }
        if (column.label === '拆分前单价') {
          sums[index] = data.reduce((pre, cur) => {
            return getNum(Big(getNum(this.contractType === '服务订单' ? cur.serviceLife : cur.productNum)).times(getNum(cur.beforeSplitProductPriceSigle)).plus(pre).toString());
          }, 0);
          this.summariesData.beforeSplitProductPriceSigle = sums[index];
        }
      });
      return sums;
    },

    // 暴露出去的数据
    getSubmitData () {
      return {
        productList: this.productList,
        summariesData: this.summariesData
      };
    }

  }
};
</script>

<style lang="scss" scoped>
.wrap {
  padding: 20px;
}

.form-item-cell {
  width: 170px;
}

.text-left {
  text-align: left;
}
</style>
